import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logCapture } from './services/logCapture';
import './styles/layout.css';

// Initialize log capture for in-app log viewer
// This intercepts console.log/error/warn and stores them
logCapture; // Just reference it to ensure it's initialized

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
